import { GroupMember, GroupRole } from '@ih/app/shared/apis/interfaces';

export class SetGroupMembers {
  public static readonly type = '[Group/GroupMember/List] SetGroupMembers';
  constructor(
    public readonly groupMembers: GroupMember[],
    public readonly groupRoles: GroupRole[],
  ) {}
}
